"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint @typescript-eslint/no-explicit-any: 0 */

var DataMessage = /*#__PURE__*/function () {
  function DataMessage(timestampMs, topic, data, senderAttendeeId, senderExternalUserId, throttled) {
    _classCallCheck(this, DataMessage);

    this.timestampMs = timestampMs;
    this.topic = topic;
    this.data = data;
    this.senderAttendeeId = senderAttendeeId;
    this.senderExternalUserId = senderExternalUserId;
    this.throttled = !!throttled;
  }
  /**
   * Helper conversion methods to convert {@link Uint8Array} data to string
   */


  _createClass(DataMessage, [{
    key: "text",
    value: function text() {
      return new TextDecoder().decode(this.data);
    }
    /**
     * Helper conversion methods to convert {@link Uint8Array} data to JSON
     */

  }, {
    key: "json",
    value: function json() {
      return JSON.parse(new TextDecoder().decode(this.data));
    }
  }]);

  return DataMessage;
}();

exports.default = DataMessage;